import { render, staticRenderFns } from "./PProductQuantitiesPicker.vue?vue&type=template&id=7070879c"
import script from "./PProductQuantitiesPicker.vue?vue&type=script&lang=js"
export * from "./PProductQuantitiesPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports